import React from "react";
import styled, { keyframes } from "styled-components";
import { Settings } from "lucide-react";

const AdminConfigLoader: React.FC = () => {
  return (
    <LoaderWrapper>
      <RotatingGear />
      <LoaderText>Loading ...</LoaderText>
    </LoaderWrapper>
  );
};

export default AdminConfigLoader;

// Styled Components

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderWrapper = styled.div`
  position: fixed;
  top: 10%;
  left: 6%;
  height: 100vh;
  width: 100vw;
  z-index: 999; /* ensures it overlays */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #094752;
`;

const RotatingGear = styled(Settings)`
  animation: ${spin} 1s linear infinite;
  width: 56px;
  height: 56px;
  stroke-width: 2.5px;
`;

const LoaderText = styled.div`
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;
